const strings = {
  en: {
    allFeaturesLabel: 'ALL FEATURES',
    allFeaturesTitle: 'One platform. Every tool you need.',
    allFeaturesCta: 'Book Free Demo',
    faqLabel: 'FAQ',
    faqTitle: 'Find the answers that you need.',
    faqImageAlt: 'FAQ Flow',
    ctaTitle: 'Ready to Get Started?',
    ctaSubtitle: "See how this feature can transform your sales team's performance.",
    ctaButton: 'Request Free Demo',
    featuresImageAlt: 'SAPOT AI Features',
  },
  zh: {
    allFeaturesLabel: '全部功能',
    allFeaturesTitle: '一个平台,所需工具一应俱全。',
    allFeaturesCta: '预约免费演示',
    faqLabel: '常见问题',
    faqTitle: '在这里找到您需要的答案。',
    faqImageAlt: '常见问题流程图',
    ctaTitle: '准备好开始了吗?',
    ctaSubtitle: '了解这项功能如何全面提升您销售团队的表现。',
    ctaButton: '申请免费演示',
    featuresImageAlt: 'SAPOT AI 功能一览',
  },
};

export default strings;
